import { isEqual } from 'lodash-es';

import type { MultiValue, SingleValue, PropsValue, ChipsOnChangeValue } from './types.ts';

export const noop = () => {};

export const valueAsSingleValue = <T>(value: PropsValue<T>): SingleValue<T> => value as SingleValue<T>;

export const valueAsMultiValue = <T>(value: PropsValue<T>): MultiValue<T> => value as MultiValue<T>;

export const onChangeAsSingle = <TValue, TMulti extends boolean>(
  onChange: (value: ChipsOnChangeValue<TValue, TMulti>) => void,
): ((value: ChipsOnChangeValue<TValue, false>) => void) => onChange as (value: ChipsOnChangeValue<TValue, false>) => void;

export const onChangeAsMulti = <TValue, TMulti extends boolean>(
  onChange: (value: ChipsOnChangeValue<TValue, TMulti>) => void,
): ((value: ChipsOnChangeValue<TValue, true>) => void) => onChange as (value: ChipsOnChangeValue<TValue, true>) => void;

export const isValueSelected = (selectedValue: PropsValue<unknown>, value: unknown, multi: boolean | undefined) =>
  multi ? valueAsMultiValue(selectedValue).some((item) => isEqual(item, value)) : isEqual(valueAsSingleValue(selectedValue), value);

// option is clickable if:
// 1. isClearable is true
// 2. multi is true and value is not selected or there are more than one selected values
// 3. multi is false and value is not selected
export const getIsClickable = (
  selectedValue: PropsValue<unknown>,
  value: unknown,
  multi: boolean | undefined,
  isClearable: boolean | undefined,
) =>
  isClearable ||
  (multi
    ? !isValueSelected(selectedValue, value, true) || valueAsMultiValue(selectedValue).length > 1
    : !isValueSelected(selectedValue, value, false));
